export default __webpack_public_path__ + "static/media/manage-teacher-white.92f5ccda.svg";